import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalHeader from "./LocalHeader";

const MenuSequencing = () => {
  const dispatch = useDispatch();
  const menuData =
    useSelector(
      (state) => state?.settingReducer?.menuSequencingData?.menudata
    ) ?? null;
  const [copiedMenuData, setCopiedMenuData] = useState();
  console.log(copiedMenuData, "copiedMenuData");

  useEffect(() => {
    dispatch(actions?.getMenuSequencingData());
  }, []);
  useEffect(() => {
    setCopiedMenuData(menuData);
  }, [menuData]);

  function handleSectionActivation(sectionId) {
    const updatedMenuData = copiedMenuData?.map((sectionEl) => {
      if (sectionId === sectionEl?.id)
        return {
          ...sectionEl,
          status: sectionEl?.status === "0" ? "1" : "0",
          items: sectionEl?.items?.map((menuItem) => ({
            ...menuItem,
            status: sectionEl?.status === "0" ? "1" : "0",
          })),
        };
      else return sectionEl;
    });
    console.log(updatedMenuData, "ppppppppppp", copiedMenuData);
    setCopiedMenuData(updatedMenuData);
  }

  function handleMenuActivation(menuId) {
    let itemFound = false;
    const updatedMenuData = copiedMenuData?.map((sectionEl) => ({
      ...sectionEl,
      items: sectionEl?.items?.map((menuItem) => {
        if (itemFound === false && menuItem?.id === menuId) {
          itemFound = true;
          return {
            ...menuItem,
            status: menuItem?.status === "0" ? "1" : "0",
          };
        } else {
          return menuItem;
        }
      }),
    }));

    updatedMenuData?.forEach((sectionEl) => {
      if (sectionEl?.items?.some((menuItem) => menuItem?.status === "1")) {
        sectionEl["status"] = "1";
      } else {
        sectionEl["status"] = "0";
      }
    });
    setCopiedMenuData(updatedMenuData);
    console.log("updatedMenu", updatedMenuData);
  }

  function handleMoveSection(direction, targetId) {
    const deepCopiedData = JSON.parse(JSON.stringify(copiedMenuData));
    const targetIdx = deepCopiedData?.findIndex(
      (section) => section?.id === targetId
    );

    console.log(targetIdx, "hhhhhhhhhhhhhhhhh");

    if (targetIdx < 0) return;

    if (direction === "up") {
      if (targetIdx === 0) return;
      const upperSequence = deepCopiedData[targetIdx - 1]?.sequence;
      const currSequence = deepCopiedData[targetIdx]?.sequence;

      deepCopiedData[targetIdx]["sequence"] = upperSequence;
      deepCopiedData[targetIdx - 1]["sequence"] = currSequence;
    } else {
      if (targetIdx === deepCopiedData?.length - 1) return;
      const lowerSequence = deepCopiedData[targetIdx + 1]?.sequence;
      const currSequence = deepCopiedData[targetIdx]?.sequence;

      deepCopiedData[targetIdx]["sequence"] = lowerSequence;
      deepCopiedData[targetIdx + 1]["sequence"] = currSequence;
    }
    console.log(deepCopiedData, "deepCopiedData");
    const finalData = deepCopiedData.sort((a, b) => a.sequence - b.sequence);
    setCopiedMenuData(finalData);
  }

  function handleMoveMenu(direction, targetMenuId, targetSectionId) {
    const deepCopiedMenuData = JSON.parse(JSON.stringify(copiedMenuData));

    const sectionIdx = deepCopiedMenuData?.findIndex(
      (section) => section.id === targetSectionId
    );

    const menuIdx = deepCopiedMenuData[sectionIdx]?.items?.findIndex(
      (menu) => menu?.id === targetMenuId
    );

    if (menuIdx < 0) return;

    if (direction === "up") {
      if (menuIdx === 0) return;

      const currentMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]?.sequence;
      const upperMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx - 1]?.sequence;
      console.log(
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]["sequence"],
        "mmmmmmmmmmmmm"
      );

      const targetArr = deepCopiedMenuData[sectionIdx]?.items;
      targetArr[menuIdx]["sequence"] = upperMenuSeq;
      targetArr[menuIdx - 1]["sequence"] = currentMenuSeq;
    }
    if (direction === "down") {
      if (menuIdx === deepCopiedMenuData[sectionIdx]?.items.length - 1) return;

      const currentMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]?.sequence;
      const lowerMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx + 1]?.sequence;
      console.log(
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]["sequence"],
        "mmmmmmmmmmmmm"
      );

      const targetArr = deepCopiedMenuData[sectionIdx]?.items;
      targetArr[menuIdx]["sequence"] = lowerMenuSeq;
      targetArr[menuIdx + 1]["sequence"] = currentMenuSeq;
    }
    deepCopiedMenuData?.forEach((sectionEl) => {
      sectionEl?.items?.sort((a, b) => a.sequence - b.sequence);
    });
    console.log(deepCopiedMenuData, "mmmmmmmmmmmmm");
    setCopiedMenuData(deepCopiedMenuData);
  }

  function handleSubmit() {
    const data = {
      push_menu_input: "yes",
      category: copiedMenuData?.map((sectionItem) => {
        return {
          id: sectionItem?.id,
          sequence: sectionItem?.sequence,
          status: sectionItem?.status,
          menu: sectionItem?.items?.map((menuItem) => ({
            category_id: sectionItem?.id,
            id: menuItem?.id,
            sequence: menuItem?.sequence,
            status: menuItem?.status,
          })),
        };
      }),
    };
    console.log(data);
    dispatch(actions?.postMenuSequencingData(data));
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 mt-3">
          <div className="container px-0">
            <LocalHeader />

            <div class="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="menu-sequencing"
                role="tabpanel"
                aria-labelledby="menu-sequencing-tab"
              >
                <div className="shadowclass mt-md-4 mt-3 integrationEditMs">
                  <h4 class="event-alert"> Ordrr QR Menu &amp; Sequencing </h4>
                  <div className="row mx-0">
                    <div className="table-responsive min-width-table">
                      <table
                        id="menu_sequencing"
                        class="checklist-table remove-space"
                      >
                        <thead>
                          <tr>
                            <th className="col-1 text-right"> Sequence ID </th>
                            <th className="col-2"> Sequence Type </th>
                            <th className="col-3"> Menu Name </th>
                            <th className="col-5"> </th>
                          </tr>
                        </thead>
                        <tbody id="menu_sequencing_body">
                          {copiedMenuData?.map((sectionItem, sectionIdx) => (
                            <tr>
                              <td colspan="4" className="p-0">
                                <table class="table category-table">
                                  <tr class="categ-tr activerow">
                                    <td class="col-1 align-right">
                                      {sectionIdx + 1}-00000
                                    </td>
                                    <td className="col-2"> Sub-Category</td>
                                    <td className="col-3">
                                      {" "}
                                      {sectionItem?.name}
                                    </td>
                                    <td className="col-5 btns-table-sec">
                                      <button
                                        onClick={() => {
                                          handleMoveSection(
                                            "up",
                                            sectionItem?.id
                                          );
                                        }}
                                        type="button"
                                        class="btn_btnblue categoryup"
                                      >
                                        Move Up Section
                                      </button>
                                      <button
                                        onClick={() => {
                                          handleMoveSection(
                                            "down",
                                            sectionItem?.id
                                          );
                                        }}
                                        type="button"
                                        class="btn_btnblue categorydown"
                                      >
                                        Move Down Section
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleSectionActivation(
                                            sectionItem?.id
                                          )
                                        }
                                        type="button"
                                        class={`btn_btnblue categorystatus ${
                                          sectionItem?.status == 1
                                            ? "deactivate"
                                            : "activate"
                                        }`}
                                      >
                                        {sectionItem?.status == 1
                                          ? "Dectivate"
                                          : "Activate"}
                                      </button>
                                    </td>
                                  </tr>
                                  {sectionItem?.items?.map(
                                    (menuItem, menuIdx) => {
                                      return (
                                        <tr class="menutr category-0 activerow">
                                          <td class="menu col-1">
                                            {" "}
                                            {sectionIdx + 1}-0000{menuIdx + 1}{" "}
                                          </td>
                                          <td className="col-2">MenuItems</td>
                                          <td className="col-3">
                                            {menuItem?.name}
                                            (1-for-1)
                                          </td>
                                          <td className="col-5 btns-table-sec">
                                            <button
                                              onClick={() => {
                                                handleMoveMenu(
                                                  "up",
                                                  menuItem?.id,
                                                  sectionItem?.id
                                                );
                                              }}
                                              type="button"
                                              class="btn_btnblue menuup"
                                            >
                                              Move Up Item
                                            </button>
                                            <button
                                              onClick={() => {
                                                handleMoveMenu(
                                                  "down",
                                                  menuItem?.id,
                                                  sectionItem?.id
                                                );
                                              }}
                                              type="button"
                                              class="btn_btnblue menudown"
                                            >
                                              Move Down Item
                                            </button>
                                            <button
                                              onClick={() => {
                                                handleMenuActivation(
                                                  menuItem?.id
                                                );
                                              }}
                                              type="button"
                                              class={`btn_btnblue categorystatus ${
                                                menuItem?.status == 1
                                                  ? "deactivate"
                                                  : "activate"
                                              }`}
                                            >
                                              {menuItem?.status == 1
                                                ? "Deactivate"
                                                : "Activate"}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="clearfix"> &nbsp; </div>

              <div class="btns d-flex justify-content-end">
                <button class="btn" name="submit" type="submit" id="cancel">
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  class="btn"
                  name="submit"
                  type="submit"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default MenuSequencing;
